import React, { Component } from "react";
import { translate } from "react-i18next";
import { Link } from "react-router-dom";
import { gaEvent } from "../../ga/analytics";
import {
	CATEGORY_FOOTER,
	ACTION_HOME,
	ACTION_AU_WHO_ARE_WE,
	ACTION_AU_WHAT_WE_DO,
	ACTION_AU_OUR_VISION,
	ACTION_AU_OUR_MISSION,
	ACTION_AU_CORE_VALUE,
	ACTION_AU_OUR_TEAM,
	ACTION_AU_JOIN_OUR_TEAM,
	ACTION_AU_PRIVACY,
	ACTION_OP_HRTABLE,
	ACTION_OP_MONEYTABLE,
	ACTION_PARTNERS_ASSOCIATIONAL,
	ACTION_PARTNERS_FINANCIAL,
	ACTION_PARTNERS_SOFTWARE,
	ACTION_PARTNERS_INSURANCE,
	ACTION_BLOGS_HR_ANSWER,
	ACTION_BLOGS_NEWS,
	ACTION_BLOGS_TIPS,
	ACTION_CU_FILL_FORM,
	ACTION_CU_REQUEST_HRTABLE,
	ACTION_CU_REQUEST_MONEYTABLE,
	CATEGORY_CONTACT_US,
	ACTION_FOOTER,
	CATEGORY_CONTACT_HRTABLE,
	ACTION_AU_TERM_CONDITION,
	ACTION_BLOGS_VOCABULARY,
	ACTION_BLOGS_FINANCIAL,
	ACTION_OP_DAYCASH,
} from "../../ga/constant";

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	sendToGa = (type) => {
		if (type === "Home") {
			gaEvent(CATEGORY_FOOTER, ACTION_HOME, this.props.page);
		}

		if (type === "AU Who") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_WHO_ARE_WE, this.props.page);
		}

		if (type === "AU What") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_WHAT_WE_DO, this.props.page);
		}

		if (type === "AU Vision") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_OUR_VISION, this.props.page);
		}

		if (type === "AU Mission") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_OUR_MISSION, this.props.page);
		}

		if (type === "AU Core Value") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_CORE_VALUE, this.props.page);
		}

		if (type === "AU Our Team") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_OUR_TEAM, this.props.page);
		}

		if (type === "AU Join Our Team") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_JOIN_OUR_TEAM, this.props.page);
		}

		if (type === "AU Term Condition") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_TERM_CONDITION, this.props.page);
		}

		if (type === "AU Privacy") {
			gaEvent(CATEGORY_FOOTER, ACTION_AU_PRIVACY, this.props.page);
		}

		if (type === "OP HRTable") {
			gaEvent(CATEGORY_FOOTER, ACTION_OP_HRTABLE, this.props.page);
		}

		if (type === "OP MoneyTable") {
			gaEvent(CATEGORY_FOOTER, ACTION_OP_MONEYTABLE, this.props.page);
		}

		if (type === "OP DayCash") {
			gaEvent(CATEGORY_FOOTER, ACTION_OP_DAYCASH, this.props.page);
		}

		if (type === "Partners Associational") {
			gaEvent(CATEGORY_FOOTER, ACTION_PARTNERS_ASSOCIATIONAL, this.props.page);
		}

		if (type === "Partners Financial") {
			gaEvent(CATEGORY_FOOTER, ACTION_PARTNERS_FINANCIAL, this.props.page);
		}

		if (type === "Partners Software") {
			gaEvent(CATEGORY_FOOTER, ACTION_PARTNERS_SOFTWARE, this.props.page);
		}

		if (type === "Partners Insurance") {
			gaEvent(CATEGORY_FOOTER, ACTION_PARTNERS_INSURANCE, this.props.page);
		}

		if (type === "Blogs HR Answer") {
			gaEvent(CATEGORY_FOOTER, ACTION_BLOGS_HR_ANSWER, this.props.page);
		}

		if (type === "Blogs News") {
			gaEvent(CATEGORY_FOOTER, ACTION_BLOGS_NEWS, this.props.page);
		}

		if (type === "Blogs Financial") {
			gaEvent(CATEGORY_FOOTER, ACTION_BLOGS_FINANCIAL, this.props.page);
		}

		if (type === "Blogs Tips") {
			gaEvent(CATEGORY_FOOTER, ACTION_BLOGS_TIPS, this.props.page);
		}

		if (type === "Blogs Vocabulary") {
			gaEvent(CATEGORY_FOOTER, ACTION_BLOGS_VOCABULARY, this.props.page);
		}

		if (type === "CU Fill Form") {
			gaEvent(CATEGORY_FOOTER, ACTION_CU_FILL_FORM, this.props.page);
			gaEvent(CATEGORY_CONTACT_US, ACTION_FOOTER, this.props.page);
		}

		if (type === "CU Request HRTable") {
			gaEvent(CATEGORY_FOOTER, ACTION_CU_REQUEST_HRTABLE, this.props.page);
			gaEvent(CATEGORY_CONTACT_HRTABLE, ACTION_FOOTER, this.props.page);
		}

		if (type === "CU Request MoneyTable") {
			gaEvent(CATEGORY_FOOTER, ACTION_CU_REQUEST_MONEYTABLE, this.props.page);
			gaEvent(CATEGORY_CONTACT_US, ACTION_FOOTER, this.props.page);
		}
	};

	render() {
		const url_lang = this.props.i18n.language === "en" ? "/en" : "";

		return (
			<footer className={this.props.i18n.language}>
				<div className="container">
					<div className="row">
						<div className="no-height-xs col-md-3 col-xs-6">
							<div className="row mb40">
								<div className="col-md-12">
									<h4 className="title">{this.props.t("hero_product")}</h4>
									<ul className="ul-list nopad">
										<li>
											<a
												href={`${url_lang}/daycash`}
												onClick={() => this.sendToGa("OP DayCash")}
											>
												DayCash
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-md-3 col-xs-6">
							<div style={{ marginBottom: "12px" }} className="row mb40">
								<div className="col-md-12">
									<h4 className="title">{this.props.t("tm_aboutus")}</h4>
									<ul className="ul-list nopad">
										<li>
											<a
												href={`${url_lang}/blog`}
												onClick={() => this.sendToGa("OP MoneyTable")}
											>
												{this.props.t("tm_blog")}
											</a>
										</li>
										<li>
											<a
												href={`${url_lang}/activity`}
												onClick={() => this.sendToGa("OP DayCash")}
											>
												{this.props.t("tm_activity")}
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-md-3 col-xs-6">
							<h4 className="title">{this.props.t("f_company")}</h4>

							<ul className="ul-list nopad">
								<li>
									<a
										href={`${url_lang}/aboutus`}
										onClick={() => this.sendToGa("OP MoneyTable")}
									>
										{this.props.t("aboutmt")}
									</a>
								</li>
								<li>
									<a
										href={`${url_lang}/aboutus#ourteam`}
										onClick={() => this.sendToGa("AU Our Team")}
									>
										{this.props.t("f_ourtea")}
									</a>
								</li>
								<li>
									<a
										href={`${url_lang}/aboutus#customer`}
										onClick={() => this.sendToGa("AU Mission")}
									>
										{this.props.t("customers")}
									</a>
								</li>
								<li>
									<a
										href={`${url_lang}/career`}
										onClick={() => this.sendToGa("AU Join Our Team")}
									>
										{this.props.t("Careers")}🚀
									</a>
								</li>
								<li>
									<a
										href={`${url_lang}/condition`}
										onClick={() => this.sendToGa("AU Term Condition")}
									>
										{this.props.t("tandc")}
									</a>
								</li>
								<li>
									<a
										href={`${url_lang}/privacy`}
										onClick={() => this.sendToGa("AU Privacy")}
									>
										{this.props.t("privacypolicy")}
									</a>
								</li>
							</ul>
						</div>
						<div className="col-md-3 col-xs-6">
							<div className="row mb40">
								<div className="col-md-12">
									<h4 className="title">{this.props.t("saleandsup")}</h4>
									<ul className="ul-list nopad">
										<li>
											<a
												href={`${url_lang}/contact`}
												onClick={() => this.sendToGa("CU Fill Form")}
											>
												{this.props.t("contactMT")}
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="container">
					<hr style={{ opacity: "0.5", height: "" }} />
					<div className="footer-cr">
						<Link to="/">
							<img
								src="/src/images/logo_mt_white.png"
								alt="moneytable"
								style={{ maxWidth: 250 }}
							/>
						</Link>
						<span>© 2021 Moneytable</span>
					</div>
				</div>
			</footer>
		);
	}
}

export default translate("translations")(Footer);



// WEBPACK FOOTER //
// ./src/components/layouts/footer.jsx